import { useEffect, useState } from "react";
import { Cookie } from "lucide-react";
import { Link } from "react-router-dom";

const CONSENT_KEY = "hexxium_cookie_consent";

export const CookieConsent = () => {
  const [choice, setChoice] = useState(() => {
    try { return localStorage.getItem(CONSENT_KEY); } catch { return "granted"; }
  });

  useEffect(() => {
    const reopen = () => setChoice(null);
    window.addEventListener("hexxium:cookie-settings", reopen);
    return () => window.removeEventListener("hexxium:cookie-settings", reopen);
  }, []);

  const decide = (value) => {
    try { localStorage.setItem(CONSENT_KEY, value); } catch { /* private mode */ }
    try {
      if (value === "granted") window.ttq?.grantConsent();
      else window.ttq?.revokeConsent();
    } catch { /* pixel blocked */ }
    try {
      window.fbq?.("consent", value === "granted" ? "grant" : "revoke");
    } catch { /* pixel blocked */ }
    setChoice(value);
  };

  if (choice) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 sm:right-auto sm:max-w-md z-[90]" data-testid="cookie-consent-banner">
      <div className="rounded-xl border border-white/10 bg-[#0B0D12]/95 backdrop-blur-xl p-4 shadow-2xl">
        <p className="text-slate-300 text-xs leading-relaxed flex items-start gap-2">
          <Cookie className="w-4 h-4 text-[#00AEEF] flex-shrink-0 mt-0.5" />
          <span>
            We use cookies and analytics to measure site performance and improve your experience.
            See our <Link to="/privacy" className="text-[#00AEEF] hover:underline">Privacy Policy</Link>.
          </span>
        </p>
        <div className="flex gap-2 mt-3">
          <button onClick={() => decide("granted")}
            className="flex-1 px-4 py-2 rounded-lg bg-[#00AEEF] hover:bg-[#0095cc] text-white text-xs font-semibold transition-colors"
            data-testid="cookie-accept-btn">
            Accept
          </button>
          <button onClick={() => decide("denied")}
            className="flex-1 px-4 py-2 rounded-lg bg-white/5 hover:bg-white/10 border border-white/10 text-slate-300 text-xs font-medium transition-colors"
            data-testid="cookie-decline-btn">
            Decline
          </button>
        </div>
      </div>
    </div>
  );
};
